export default __webpack_public_path__ + "static/media/floppy-disk.98555479.png";